import { render, staticRenderFns } from "./ScrollAccordions.vue?vue&type=template&id=38114020&scoped=true"
import script from "./ScrollAccordions.vue?vue&type=script&lang=js"
export * from "./ScrollAccordions.vue?vue&type=script&lang=js"
import style0 from "./ScrollAccordions.vue?vue&type=style&index=0&id=38114020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38114020",
  null
  
)

export default component.exports